export default __webpack_public_path__ + "./image/8e00d1675452e63e974db2b3ca17d33b.png";